import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from './../../hooks/redux/themeSlice';
import './Theme.css';

export const ThemeContext = React.createContext();

export const ThemeProvider = ({ children }) => {
    const theme = useSelector((state) => state.theme.theme);
    const dispatch = useDispatch();

    const handleToggleTheme = () => {
        dispatch(toggleTheme());
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme: handleToggleTheme }}>
            <div className={theme}>
                {children}
            </div>
        </ThemeContext.Provider>
    );
};
